function getCookieValue(name) {
  return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''; // eslint-disable-line prefer-template
}

function isCookiePresent(name) {
  return Boolean(getCookieValue(name));
}

function writeCookie(name, value, expiryDate, path = '/') {
  document.cookie = `${name}=${value}; expires=${expiryDate}; path=${path}`;
}

function writeCookieExpiryByMonths(name, value, months = 1, path = '/') {
  const expiryDate = new Date();
  expiryDate.setMonth(expiryDate.getMonth() + months);
  document.cookie = `${name}=${value}; expires=${expiryDate}; path=${path}`;
}

function removeCookie(name, path = '/') {
  const expireYesterdayDate = new Date();
  expireYesterdayDate.setDate(expireYesterdayDate.getDate() - 1);
  writeCookie(name, '', expireYesterdayDate.toUTCString(), path);
}

export {
  isCookiePresent,
  writeCookieExpiryByMonths,
  removeCookie,
};
